<template>
  <div :class="{ isMobile }" class="page-wrapper">
    <InscribeWarningBanner />
    <mobile-header
      v-if="isMobile"
      @toggle-left-nav="onLeftNavToggle"
    ></mobile-header>
    <div
      class="app-wrapper d-flex flex-row"
      :class="screenSize"
      style="height: 100%"
    >
      <left-nav
        v-if="!isMobile || leftNavToggle"
        class="sidebar-wrapper"
        :screen-size="screenSize"
        @left-nav-size-change="setLeftNavWidth"
      ></left-nav>
      <div
        :style="{ paddingLeft: isMobile ? 0 : leftNavWidth + 'px' }"
        class="main-content-wrapper flex-grow-1"
        v-if="!currentUser?.is_geoblocked"
      >
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>

      <div
        v-if="shouldShowReadOnlyBanner || shouldShowCustomerDataWarningBanner"
        class="banner-container d-flex"
      >
        <div
          v-if="shouldShowReadOnlyBanner"
          class="banner banner--info"
          data-testid="read-only-banner"
        >
          This workspace is in read-only mode
        </div>
        <div
          v-if="shouldShowCustomerDataWarningBanner"
          class="banner banner--warning"
          data-testid="customer-data-warning-banner"
        >
          Customer account. Don't upload or change anything.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftNav from './navigation/LeftNav';
import MobileHeader from './navigation/MobileHeader';
import { isInternalStaff } from '@/utils/user';
import InscribeWarningBanner from './InscribeWarningBanner.vue';
import { mapState } from 'vuex';

export default {
  components: {
    LeftNav,
    MobileHeader,
    InscribeWarningBanner,
  },
  data: () => ({
    leftNavToggle: false,
    screenSize: null,
    leftNavWidth: 0,
  }),
  computed: {
    ...mapState(['currentUser']),
    shouldShowReadOnlyBanner() {
      // If the feature flag is on, we want to show this message to all users
      // including Inscribe staff
      return this.$store.state.featureFlagsStore.featureFlags
        .block_upload_access;
    },
    shouldShowCustomerDataWarningBanner() {
      return (
        this.$store.state.currentUser?.is_superuser &&
        this.$store.state.customers.selectedCustomer?.creator &&
        !isInternalStaff(this.$store.state.customers.selectedCustomer.creator)
      );
    },
    isMobile() {
      return this.screenSize === 'mobile' || this.screenSize === 'small0';
    },
  },
  mounted() {
    this.setScreenType();
    window.addEventListener('resize', this.setScreenType);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setScreenType);
  },
  methods: {
    setLeftNavWidth(width) {
      this.leftNavWidth = width;
    },
    onLeftNavToggle() {
      this.leftNavToggle = !this.leftNavToggle;
    },
    onWindowResize() {
      this.setScreenType();
    },
    setScreenType() {
      const breakPointMap = {
        mobile: 500,
        small0: 768,
        small1: 900,
        small2: 1240,
        small3: 1424,
        mediumLarge: 1548,
      };
      for (const pointName of Object.keys(breakPointMap)) {
        this.screenSize = 'lg';
        if (window.innerWidth < breakPointMap[pointName]) {
          this.screenSize = pointName;
          break;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.main-content-wrapper {
  width: 100%;
  height: 100%;
}

.page-wrapper {
  height: 100%;
}

.content_card {
  min-height: 100%;
  background: $color-off-white;
  padding: 32px;
}

.sidebar-wrapper {
  z-index: 1000;
  bottom: 0;
  left: 0;
  position: fixed;
  top: 0;
}

.app-wrapper.small0,
.app-wrapper.mobile {
  margin-left: 0;
}

.notification div {
  font-size: 1rem !important;
}

.notification-wrapper {
  margin-top: 20px;
}

.banner-container {
  position: fixed;
  z-index: 100000;
  bottom: 0;
  right: 260px;

  &:hover {
    cursor: default;
    display: none !important;
  }

  .banner {
    color: #fff;
    text-align: center;
    font-size: 0.95rem;
    opacity: 80%;
    padding: 8px;

    &:first-child {
      border-radius: 5px 5px 0px 0px;
    }

    &--info {
      background: gray;
    }

    &--warning {
      background: red;
    }
  }
}

@media only screen and (max-width: 680px) {
  .button-desc {
    display: none !important;
  }
}

.good {
  background-color: $color-green !important;
  color: $color-white !important;
}

.bad {
  background-color: $color-warning-red !important;
  color: $color-white !important;
}

$container-max-height: calc(100vh - #{$margin-modal-y * 2} - 130px);
$container-max-height-with-actions: calc(
  100vh - #{$margin-modal-y * 2} - 130px - 172px
);
.pdf-viewer {
  max-height: $container-max-height;
  position: relative;

  &:not(.page-list) {
    min-height: $container-max-height;
  }

  iframe {
    height: $container-max-height;
  }

  .pdf-wrapper {
    overflow: auto;
    max-height: 100%;
    max-width: 100%;
    width: 100%;

    img {
      display: block;
      margin: auto;
    }
  }
}

.document-actions + .pdf-viewer.page-list {
  max-height: $container-max-height-with-actions;
}
</style>
